<template lang="pug">
  div(class="trash-can-type block--normal")
    div
      span(class="font-18") 垃圾種類
      time-picker(:time="time" :format="'yyyy / MM'" :minView="'month'" :img="`${require('@/assets/icon/drop_down.svg')}`" @changeChartData ="changeChartData")
    div(class="content")
      div(class="content__chart")
        pie-chart(:cateCount="cateCount")
      div(class="content__type")
        div(class="type__item" v-for="type in types")
          div(:class="`type-mark__${type}`")
          span {{type2ZH(type)}}
</template>

<script>
import TimePicker from '@/components/TimePicker.vue'
import PieChart from '@/components/chart/PieChart.vue'
import apis from '@/apis/api.js'
export default {
  name: 'TrashCanType',
  components: {
    TimePicker,
    PieChart
  },
  data () {
    return {
      types: ['trash', 'plastic', 'metal', 'paper'],
      time: '2020-12',
      lastestCateCount: []
    }
  },
  created () {
    this.getTotalCateCount(this.time)
  },
  computed: {
    cateCount () {
      return this.lastestCateCount
    }
  },
  methods: {
    type2ZH (type) {
      switch (type) {
        case 'trash':
          return '廢棄物'
        case 'plastic':
          return '塑膠'
        case 'metal':
          return '鐵鋁罐'
        case 'paper':
          return '紙類'
      }
    },
    async getTotalCateCount (time) {
      const { data } = await apis.getTotalStatistics(time)
      let cateCount = data.cateCount
      if (cateCount.length === 0) {
        this.lastestCateCount = [0, 0, 0, 0]
      } else {
        this.lastestCateCount = cateCount[cateCount.length - 1].amount
      }
    },
    changeChartData (time) {
      this.getTotalCateCount(time.slice(0, 7))
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/helper/variables.scss";

@mixin decoration() {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background-color: map-get($colors, dark-red);
  margin-right: 8px;
}
$types: (
  trash: #dddddd,
  plastic: map-get($colors, red),
  metal: map-get($colors, light-blue),
  paper: map-get($colors, green),
) !default;

.trash-can-type {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 30%;
  > div:nth-child(1) {
    text-align: left;
    display: flex;
    align-items: center;
    > span {
      margin-right: 10px;
    }
  }
  .content {
    display: flex;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    overflow: visible;
    &__chart {
      height: 100%;
      flex: 1;
      margin-right: 30px;
    }
    &__type {
      display: flex;
      width: 70px;
      height: 100%;
      padding: 30px 0 30px 0;
      box-sizing: border-box;
      flex-direction: column;
      justify-content: space-between;
    }
  }
  .type {
    &__item {
      display: flex;
      align-items: center;
      font-size: 12px;
      .type-mark {
        &__trash {
          @include decoration;
          background-color: map-get($types, trash);
        }
        &__plastic {
          @include decoration;
          background-color: map-get($types, plastic);
        }
        &__metal {
          @include decoration;
          background-color: map-get($types, metal);
        }
        &__paper {
          @include decoration;
          background-color: map-get($types, paper);
        }
      }
    }
  }
}
</style>
